import type { IconProps } from './types';
import './icons.css';

export default function Attention({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-attention ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M19.167 16.667 10 1.417.833 16.667h18.334ZM10.833 15H9.167v-1.667h1.666V15Zm0-3.333H9.167V7.5h1.666v4.167Z"
      />
    </svg>
  );
}
